// extracted by css-extract-rspack-plugin
export default {"cls1":"ReferenceCard-cls1_eyU","cls2":"ReferenceCard-cls2_LA1 ReferenceCard-cls1_eyU"};